// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.plc-section {
  display: flex;
  flex-direction: column;
  gap: 12px;
  max-width: 640px;
  padding: 20px;
  border: 1px solid var(--rule);
  border-radius: 8px;
  background: var(--paper-elev);
}

.plc-section__title {
  margin: 0;
  font-size: 1.1rem;
  font-weight: 600;
  color: var(--ink);
}

.plc-section__body,
.plc-source {
  margin: 0;
  font-size: 0.9rem;
  color: var(--ink-2);
}

.plc-error {
  margin: 0;
  color: var(--danger);
}

.plc-options {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin: 0;
  padding: 0;
  border: 0;
}

.plc-options__legend {
  margin-bottom: 4px;
  font-family: var(--font-mono);
  font-size: 11px;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  color: var(--ink-3);
}

.plc-option {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 10px 12px;
  border: 1px solid var(--rule);
  border-radius: 6px;
  cursor: pointer;
}

.plc-option:has(input:checked) {
  border-color: var(--accent);
}

.plc-options:disabled .plc-option {
  cursor: default;
}

.plc-option input {
  margin-top: 3px;
  accent-color: var(--accent);
}

.plc-option__text {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.plc-option__label {
  font-weight: 600;
  color: var(--ink);
}

.plc-option__current {
  font-weight: 400;
  color: var(--ink-3);
}

.plc-option__hint {
  font-size: 0.85rem;
  color: var(--ink-2);
}

.plc-actions {
  display: flex;
}
`, "",{"version":3,"sources":["webpack://./src/pages/plataforma/PlataformaConfiguracion.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;EAChB,aAAa;EACb,6BAA6B;EAC7B,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;;EAEE,SAAS;EACT,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,SAAS;EACT,UAAU;EACV,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,6BAA6B;EAC7B,eAAe;EACf,qBAAqB;EACrB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,6BAA6B;EAC7B,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf","sourcesContent":[".plc-section {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  max-width: 640px;\n  padding: 20px;\n  border: 1px solid var(--rule);\n  border-radius: 8px;\n  background: var(--paper-elev);\n}\n\n.plc-section__title {\n  margin: 0;\n  font-size: 1.1rem;\n  font-weight: 600;\n  color: var(--ink);\n}\n\n.plc-section__body,\n.plc-source {\n  margin: 0;\n  font-size: 0.9rem;\n  color: var(--ink-2);\n}\n\n.plc-error {\n  margin: 0;\n  color: var(--danger);\n}\n\n.plc-options {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  margin: 0;\n  padding: 0;\n  border: 0;\n}\n\n.plc-options__legend {\n  margin-bottom: 4px;\n  font-family: var(--font-mono);\n  font-size: 11px;\n  letter-spacing: 0.1em;\n  text-transform: uppercase;\n  color: var(--ink-3);\n}\n\n.plc-option {\n  display: flex;\n  align-items: flex-start;\n  gap: 10px;\n  padding: 10px 12px;\n  border: 1px solid var(--rule);\n  border-radius: 6px;\n  cursor: pointer;\n}\n\n.plc-option:has(input:checked) {\n  border-color: var(--accent);\n}\n\n.plc-options:disabled .plc-option {\n  cursor: default;\n}\n\n.plc-option input {\n  margin-top: 3px;\n  accent-color: var(--accent);\n}\n\n.plc-option__text {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.plc-option__label {\n  font-weight: 600;\n  color: var(--ink);\n}\n\n.plc-option__current {\n  font-weight: 400;\n  color: var(--ink-3);\n}\n\n.plc-option__hint {\n  font-size: 0.85rem;\n  color: var(--ink-2);\n}\n\n.plc-actions {\n  display: flex;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
